import{defineMessages}from'react-intl';

export default defineMessages({
label:{
id:'select_contact.label',
defaultMessage:'Event Contact'},

addNewContact:{
id:'select_contact.addNewContact',
defaultMessage:'ADD NEW CONTACT'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9DcmVhdGVFdmVudFBhZ2UvU2VsZWN0Q29udGFjdC9TZWxlY3RDb250YWN0Lm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwibGFiZWwiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwiYWRkTmV3Q29udGFjdCJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsTUFBTztBQUNMQyxHQUFJLHNCQURDO0FBRUxDLGVBQWdCLGVBRlgsQ0FEcUI7O0FBSzVCQyxjQUFlO0FBQ2JGLEdBQUksOEJBRFM7QUFFYkMsZUFBZ0IsaUJBRkgsQ0FMYSxDQUFmLENBQWYiLCJmaWxlIjoiU2VsZWN0Q29udGFjdC5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBsYWJlbDoge1xuICAgIGlkOiAnc2VsZWN0X2NvbnRhY3QubGFiZWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnRXZlbnQgQ29udGFjdCcsXG4gIH0sXG4gIGFkZE5ld0NvbnRhY3Q6IHtcbiAgICBpZDogJ3NlbGVjdF9jb250YWN0LmFkZE5ld0NvbnRhY3QnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQUREIE5FVyBDT05UQUNUJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateEventPage/SelectContact/SelectContact.messages.js
// module id = 2061
// module chunks = 0